'use client';

import { cn } from '@core/utils';
import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { SUB_DOMAIN } from '@/constants';
import { useDeviceInfoStore } from '@/stores/DeviceStore';

interface Card {
  image: number;
  href: string;
  target?: string;
}

const STATIC_BANNERS = {
  '사장님 카드': {
    image: 1,
    href: '/community/policyInfo/f75177be-4665-4cb8-b6c3-f23e71555322',
  },
  'K 패스': {
    image: 2,
    href: 'https://www.ibk.co.kr/cardbiz/detailBizNew.ibk?PDLN_CD=12&PDGR_CD=11&PDTM_CD=258&PDCD=0004&mz_cd=ADGROUN&ad_cd=wello',
    target: '_blank',
  },
  디지털서비스개방만족도조사: {
    image: 4,
    href: 'http://survey.wowsurvey.com/mois',
    target: '_blank',
  },
} as Record<string, Card & { expiredAt?: string }>;

type StaticBannerList = keyof typeof STATIC_BANNERS;

interface StaticBannerProps {
  bannerList: StaticBannerList[];
  className?: string;
}

export const StaticBanner = ({ bannerList, className }: StaticBannerProps) => {
  const subDomain = useDeviceInfoStore((state) => state.subDomain);

  const filteredBannerList = bannerList.filter((banner) => {
    if (banner === 'K 패스' && subDomain === SUB_DOMAIN.KB_PAY) {
      return false;
    }

    return true;
  });

  const autoplayPlugin = Autoplay({ delay: 5_000, stopOnInteraction: false });
  const [emblaRef] = useEmblaCarousel(
    {
      loop: true,
      align: 'start',
    },
    [autoplayPlugin],
  );

  return (
    <section className={cn('w-full overflow-hidden rounded-small', className)}>
      <div className="relative overflow-hidden" ref={emblaRef}>
        <div className="flex gap-8">
          {filteredBannerList.map((banner) => {
            const item = STATIC_BANNERS[banner];

            const target = 'target' in item ? item.target : undefined;

            return (
              <div key={banner} className="min-w-0 flex-[0_0_100%]">
                <CustomLink
                  aria-label={banner}
                  href={item.href}
                  target={target}
                >
                  <Image
                    alt={banner}
                    height={203}
                    src={`/assets/pngs/banner/${item.image}.png`}
                    width={810}
                  />
                </CustomLink>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
